import { LoaderListBullets } from "pro-features/components/Loaders/src/LoaderListItems";
import type { ICategoryShareServices } from "app/pages/industry-analysis/category-share/CategoryShareTypes";
import {
    GraphContentContainer,
    LoaderContainer,
} from "app/pages/industry-analysis/category-share/CategoryShareGraph/CategoryShareGraphStyles";
import { CategoryShareGraphPngHeader } from "./components/CategoryShareGraphPngHeader";
import { Legends } from "app/components/React/Legends/Legends";
import Chart from "pro-features/components/Chart/src/Chart";
import type { ICategoryShareAdaptedGraphData, ICategoryShareGraphLegend } from "./CategoryShareGraphTypes";
import { ChartStyleProvider } from "app/pages/industry-analysis/category-share/CategoryShareGraph/styled";
import { LegendWithOneLineCheckboxFlexWithSubtitle } from "@similarweb/ui-components";

export const CategoryShareGraphBody = (props: {
    isLoading: boolean;
    params: any;
    services: ICategoryShareServices;
    graphLegend: ICategoryShareGraphLegend[];
    graphData: ICategoryShareAdaptedGraphData[];
    graphConfig: any;
    onSetGraphRef: (ref) => void;
    onToggleGraphLegend: (legendItem: { name: string }) => void;
}) => {
    const { isLoading, onSetGraphRef, onToggleGraphLegend, params, services, graphData, graphLegend, graphConfig } =
        props;
    if (isLoading)
        {return (
            <LoaderContainer>
                <LoaderListBullets />
            </LoaderContainer>
        );}

    // Upon rendering the graph content, we also render a PNG header.
    // this is an invisible element, that will appear only when exporting the graph to PNG.
    return (
        <GraphContentContainer ref={onSetGraphRef}>
            <CategoryShareGraphPngHeader
                params={params}
                services={services}
            />
            <Legends
                legendItems={graphLegend}
                toggleSeries={onToggleGraphLegend}
                legendComponent={LegendWithOneLineCheckboxFlexWithSubtitle}
                legendsGap={"8px"}
            />
            <ChartStyleProvider>
                <Chart
                    isPureConfig={false}
                    type="area"
                    data={graphData}
                    config={graphConfig}
                />
            </ChartStyleProvider>
        </GraphContentContainer>
    );
};
